// src/pages/PartnerPage.js
import React from 'react';
import Footer from '../components/Footer';
import unicon1 from '../assets/unicon1.jpg'; // This will be the hero background image
import './PartnerPage.css';
import '../index.css';

import uniconLogoWhite from '../assets/Unicon-Logo-White.webp';
import uniconLogoBlue from '../assets/Unicon-Logo-Blue.webp';

const PartnerPage = () => {
return (
 <>
 {/* Main content wrapper */}
<main className="partnerPage">

 {/* NEW HERO SECTION (Image with overlaid text, like Services page) */}
<header className="partnerPageHeroHeader" style={{ backgroundImage: `url(${unicon1})` }}>
 <img src={uniconLogoWhite} alt="UNICON Logo" className="uniconLogoContent" />
<h1>About Our Partnership with UNICON</h1>
<p>A shared commitment to insight, innovation, and impact in business education</p>
</header>

        {/* The rest of the content will follow this hero */}
 <section className="partnerContent">
 <div className="partnerIntroSection">
 <p>At Nexed Insight, we are proud to partner with UNICON, the global consortium for university executive education. As a founding partner, UNICON has played a central role in shaping both our vision and our approach—helping ensure that our research speaks directly to the realities and opportunities facing providers and learning leaders today.</p>
 <p>For over 50 years, UNICON has been a driving force in advancing executive education around the world. Its global membership of more than 100 business schools represents the leading edge of university-based learning—committed to continuous innovation, applied research, and societal impact.</p></div>

<div className="uniconRoles">
 <img src={uniconLogoBlue} alt="UNICON Logo" className="uniconLogoContent" />
 <h3>As well as world-wide a network, UNICON is a convenor, connector, and catalyst for progress in the sector. It brings:</h3>
<ul>
<li>Deep relationships with business school leaders, faculty, and program designers</li>
<li>A unique vantage point on trends shaping executive education—from digital delivery to inclusive leadership</li>
 <li>A long-standing focus on quality, client value, and the evolving demands of global business</li>
 </ul>
 <p>These strengths make UNICON an ideal partner for Nexed Insight. Our collaboration is grounded in a shared belief in the power of business education to create positive impact.</p></div>

<div className="partnershipImpact">
 <h3>Together, we are building a platform for insight and foresight that helps:</h3>
 <ul>
 <li>Learning buyers make smarter, more strategic partner decisions</li>
 <li>Providers better align with client priorities and differentiate meaningfully</li>
 <li>The wider sector close persistent gaps between intent and impact</li>
 </ul>
 <p>Our partnership is a research alliance built on a shared commitment to helping the field adapt, evolve, and lead with integrity. We’re excited to continue this work in partnership with UNICON, offering value to its member institutions, contributing new evidence and shared understanding to support the future of executive learning.</p>
</div>
</section>
</main>

{/* Footer at the bottom */}
 <Footer />
 </>
 );
};

export default PartnerPage;